// Servicio para obtener cotización del dólar blue
class DolarService {
  constructor() {
    this.cache = null;
    this.lastFetch = null;
    this.CACHE_DURATION = 5 * 60 * 1000; // 5 minutos en millisegundos
  }

  async getDolarBlue() {
    try {
      // Verificar si tenemos cache válido
      if (this.cache && this.lastFetch && (Date.now() - this.lastFetch < this.CACHE_DURATION)) {
        return this.cache;
      }

      const response = await fetch('https://dolarapi.com/v1/dolares/blue');
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      
      // Validar que tenemos los datos necesarios
      if (!data.venta || typeof data.venta !== 'number') {
        throw new Error('Datos de cotización inválidos');
      }

      // Actualizar cache
      this.cache = {
        compra: data.compra,
        venta: data.venta,
        fechaActualizacion: data.fechaActualizacion
      };
      this.lastFetch = Date.now();

      return this.cache;

    } catch (error) {
      console.error('Error al obtener cotización del dólar blue:', error);
      
      // Si hay error pero tenemos cache, usar cache aunque esté vencido
      if (this.cache) {
        console.warn('Usando cotización en cache debido a error en API');
        return this.cache;
      }
      
      // Si no hay cache, devolver valor por defecto
      console.warn('Usando cotización por defecto debido a error en API');
      return {
        compra: 1000,
        venta: 1020,
        fechaActualizacion: new Date().toISOString()
      };
    }
  }

  // Convertir ARS a USD usando dólar blue
  async convertArsToUsd(arsAmount) {
    try {
      const cotizacion = await this.getDolarBlue();
      const usdAmount = arsAmount / cotizacion.venta;
      return Math.round(usdAmount);
    } catch (error) {
      console.error('Error en conversión ARS a USD:', error);
      return Math.round(arsAmount / 1020); // Valor por defecto
    }
  }

  // Limpiar cache (útil para testing)
  clearCache() {
    this.cache = null;
    this.lastFetch = null;
  }
}

// Exportar instancia singleton
export const dolarService = new DolarService();
export default dolarService;
